<template>
    <div class="modal fade" id="ChangePasswordPopup" tabindex="-1" role="dialog" aria-labelledby="ChangePasswordPopup"
        aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
        <div class="modal-dialog modal-dialog-centered ito-popup forgot-popup" role="document">
            <div class="modal-content box-shadow-main">
                <div class="close-popup" data-bs-dismiss="modal"></div>
                <div class="forgot-popup-header">
                    <h3 class="popup-title">{{ $t('change_password') }}</h3>
                </div>
                <template>
                    <div class="forgot-popup-content">
                        <p>{{ $t('password_description') }}</p>
                        <div class="form-group">
                            <label class="label-input" style="display: block">{{ $t('current_password') }}</label>
                            <div class="input-pass">
                                <input :type="showPass ? 'text' : 'password'" class="ito-input"
                                    :placeholder="$t('placeholder_current_password')" v-model="current_password"
                                    autocomplete="off">
                                <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                                    @click="showPass = !showPass"></span>
                            </div>
                            <div class="error-message text-left" v-if="errors.current_password != ''">{{
                                errors.current_password }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="label-input" style="display: block">{{ $t('new_password') }}</label>
                            <div class="d-flex">
                                <div class="input-pass">
                                    <input :type="showNewPass ? 'text' : 'password'" class="ito-input" name="new_password"
                                        :placeholder="$t('placeholder_new_password')" v-model="new_password"
                                        autocomplete="off">
                                    <span :class="[showNewPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                                        @click="showNewPass = !showNewPass"></span>
                                </div>
                                <div class="validate-new-pass" :class="classStrength" v-if="new_password">
                                    <div class="progres-status-pw d-flex">
                                        <div
                                            :class="strength > 0 ? 'progres-status-pw-item active' : 'progres-status-pw-item'">
                                        </div>
                                        <div
                                            :class="strength > 1 ? 'progres-status-pw-item active' : 'progres-status-pw-item'">
                                        </div>
                                        <div
                                            :class="strength > 2 ? 'progres-status-pw-item active' : 'progres-status-pw-item'">
                                        </div>
                                    </div>
                                    <div class="progres-text-pw">
                                        {{ textStrength }}
                                    </div>
                                </div>
                            </div>
                            <div class="error-message text-left" v-if="errors.new_password != ''">{{
                                errors.new_password }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="label-input" style="display: block">{{ $t('confirm_password') }}</label>
                            <div class="input-pass">
                                <input :type="showConfirmPass ? 'text' : 'password'" class="ito-input"
                                    name="confirm_password" :placeholder="$t('placeholder_confirm_password')"
                                    v-model="confirm_password" autocomplete="off">
                                <span :class="[showConfirmPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                                    @click="showConfirmPass = !showConfirmPass"></span>
                            </div>
                            <div class="error-message text-left" v-if="errors.confirm_password != ''">{{
                                errors.confirm_password }}
                            </div>
                        </div>

                    </div>

                    <div class="forgot-popup-footer">
                        <div class="form-group d-flex justify-content-center">
                            <div :class="(current_password != '' && new_password != '' && confirm_password != '' && current_password != new_password && errors.confirm_password == '' && errors.new_password == '') ? 'ito-btn-small active' : 'ito-btn-small'"
                                @click="(current_password != '' && new_password != '' && confirm_password != '' && current_password != new_password && errors.confirm_password == '' && errors.new_password == '') ? changeNewPass() : ''">
                                {{ $t('save') }}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { getAvatars, updateAvatar, updateProfile } from '../../models/profile'
import { changeNewPassword } from '../../models/auth'
import axios from "axios";
import '/public/themes/ito/css/profile.css';
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';

export default {
    name: "ChangePasswordModal",

    data() {
        return {
            errors: {
                current_password: '',
                new_password: '',
                confirm_password: '',
            },
            user: {
                fullname: '',
                birthday: '',
                gender: '',
                grade: 0,
                type: 2,
                avatar_id: -1,
                avatar_id_before: -1,
                avatar_img: '',
                emoji_id: 0,
                emoji_id_before: 0,
                extension_file: 'png',
                student_type: 0,
                user_name: '',
                change_avatar: 0,
                change_emoji: 0
            },
            showPass: false,
            showNewPass: false,
            showConfirmPass: false,

            current_password: '',
            new_password: '',
            confirm_password: '',
            strength: 0,
            classStrength: '',
            textStrength: '',
            error_message: '',
        };
    },

    computed: {
        user_info() {
            const user = this.$store.state.user_info;
            this.user.fullname = user.fullname;
            this.user.birthday = user.birthday;
            this.user.gender = user.gender;
            this.user.grade = user.grade;
            this.user.avatar_id = user.avatar_id;
            this.user.avatar_id_before = user.avatar_id;
            this.user.emoji_id = user.emoji_id;
            this.user.emoji_id_before = user.emoji_id;
            this.user.emoji_url = user.emoji_url;
            this.user.avatar_img = user.avatar_url;
            this.user.student_type = user.student_type;
            this.user.user_name = user.username;
            this.user.change_avatar = 0;
            this.user.change_emoji = 0;
            return this.$store.state.user_info
        }
    },

    watch: {
        'new_password': function (newVal, oldVal) {
            console.log(this.user_info.username);
            if (newVal == this.current_password && newVal !='') {
                this.errors.new_password = this.$i18n.t('new_password_cannot_be_the_same_as_the_current_password');
            } else if (newVal == this.user_info.username) {
                this.errors.new_password = this.$i18n.t('new_password_cannot_be_the_same_as_the_student_username');
            } else {
                this.errors.new_password = "";
            }
            this.strengPassword(newVal);
        },
        'strength': function (newVal, oldVal) {
            if (newVal == 1) {
                this.classStrength = 'pw-weak';
                this.textStrength = this.$i18n.t('password_strength_weak');
            } else if (newVal == 2) {
                this.classStrength = 'pw-normal';
                this.textStrength = this.$i18n.t('password_strength_good');
            } else if (newVal == 3) {
                this.classStrength = 'pw-strong';
                this.textStrength = this.$i18n.t('password_strength_strong');
            } else {
                this.classStrength = '';
                this.textStrength = '';
            }
        },
        'confirm_password': function (newVal, oldVal) {
            this.errors.confirm_password = (newVal != this.new_password) ? this.$i18n.t('password_and_confirmation_password_do_not_match') : '';
        }
    },
    methods: {
        showError(message) {
            this.error_message = message;

            $('.modal').modal('hide');

            $('#errorModal').modal('show');
        },

        changeNewPass() {
            const that = this;
            const formData = new FormData();
            if (that.new_password.length < 8) {
                that.errors.new_password = 'The new password must be at least 8 characters.';
                return false;
            }
            formData.append('old_pass', that.current_password)
            formData.append('new_pass', that.new_password);
            formData.append('confirm_pass', that.confirm_password);

            that.$store.commit("setLoading", true);

            changeNewPassword(formData).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    that.errors.current_password = "Your current password your entered is invalid.";
                    return;
                }
                $('#ChangePasswordPopup').modal('hide');
                $('#changePassSuccess').modal('show');
                that.resetPasswordState();
            }).catch((response) => {
                that.$store.commit("setLoading", false);
                console.error(response)
            });
        },
        resetPasswordState() {
            this.current_password = '';
            this.new_password = '';
            this.confirm_password = '';
        },
        strengPassword(password) {
            let str1 = 0;
            let str2 = 0;
            let str3 = 0;
            (password.length >= 8) ? str1 = 1 : str1 = 0;
            (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) ? str2 = 1 : str2 = 0;
            (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) ? str3 = 1 : str3 = 0;
            this.strength = str1 + str2 + str3;
        },
    }
}
</script>

<style scoped>
/*only this page*/
.form-control[readonly]:disabled {
    background: #EEF0F7;
}

.ito-input {
    width: 280px;
}

.form-group {
    margin-bottom: 0;
    margin-top: 10px;
}

p {
    margin-bottom: 0;
}

.label-input {
    margin-bottom: 0;
}

.error-message {
    margin-top: 5px;
}

/*only this page*/

.forgot-popup {
    width: 550px;
    max-width: 550px;
}

.forgot-popup .modal-content {
    position: relative;
    height: 470px;
    padding: 0px;
}

.forgot-popup-header {
    border-bottom: 1px solid #E5E5E5;
    padding: 20px 0;
}

.forgot-popup-content {
    position: relative;
    height: 320px;
    padding: 20px 50px;
}

.forgot-popup-footer {
    border-top: 1px solid #E5E5E5;
    padding: 20px 0;
}

.popup-title {
    margin-bottom: 0;
}

.forgot-popup-content {
    font-size: 14px;
    line-height: 19px;
    margin: 0;
}

/*validate*/

.validate-new-pass {
    display: flex;
    height: 40px;
    margin-left: 10px;
    flex-direction: column;
    justify-content: space-evenly;
}

.progres-status-pw-item {
    width: 18px;
    height: 8px;
    border: 1px solid #000;
    border-radius: 3px;
    margin-right: 4px;
}

.progres-text-pw {
    display: block;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    font-weight: 700;
}

.pw-weak .progres-status-pw-item.active {
    background: #FA450F;
    border-color: #FA450F;
}

.pw-normal .progres-status-pw-item.active {
    background: #FFA800;
    border-color: #FFA800;
}

.pw-strong .progres-status-pw-item.active {
    background: #98C93C;
    border-color: #98C93C;
}

.pw-weak .progres-text-pw {
    color: #FA450F;
}

.pw-normal .progres-text-pw {
    color: #FFA800;
}

.pw-strong .progres-text-pw {
    color: #98C93C;
}

.modal-success {
    text-align: center;
}

.modal-success .title {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
}

.modal-success h6 {
    margin: 15px 0px 0px;
    font-size: 14px;
    line-height: 19px;
}

.input-pass {
    width: 280px;
}

.cropper {
    height: 215px;
    background: #DDD;
}

.form-control[readonly] {
    background-color: #ffffff;
}

.error-message.has-form {
    margin-bottom: 10px;
    margin-top: -10px;
}

.ito-btn-small {
    border: 1px solid transparent;
}

.emo_show {
    opacity: 1;
}

.emo_hide {
    opacity: 0;
}

.profile-update .col-form-label {
    text-align: left;
}

.test_button {
    color: #40c0f6;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 40px;
    font-size: 15px;
}
</style>
